import React from "react";
import MonthlyDonationHero from "./MonthlyDonationHero";
import MonthlySteps from "./MonthlySteps";
import MonthlyDonationPrograms from "./MonthlyDonationProgram";
import WhyChooseUs from "./WhyChooseUs";

const Index = () => {
  return (
    <>
      <MonthlyDonationHero />
      <MonthlySteps />
      <MonthlyDonationPrograms />
      <WhyChooseUs />
    </>
  );
};

export default Index;
